/* eslint-disable */
// @ts-nocheck

export function initMessageBox() {
	const bynder = window.bynder || (window.bynder = {});
	bynder.modules = bynder.modules || {};

	bynder.modules.MessageBox = (function () {
		// Private
		let _rootNode,
			_timeout,
			_originalTitle = document.title,
			_blinkInterval;

		const _cancelNotification = function () {
			if (_blinkInterval !== null && _blinkInterval !== undefined) {
				clearInterval(_blinkInterval);
			}
			document.title = _originalTitle;
		};

		const _notify = function (message) {
			clearInterval(_blinkInterval);

			let i = 0;
			_blinkInterval = setInterval(function () {
				document.title = i++ % 2 ? message : _originalTitle;
			}, 1000);

			const onMouseMove = function () {
				_cancelNotification();
				window.removeEventListener('mousemove', onMouseMove);
			};

			window.addEventListener('mousemove', onMouseMove, { once: true });
		};

		// Public
		return {
			initialize: function () {
				const self = this;
				_rootNode = document.querySelector('.update');

				if (!_rootNode) return;

				// Fix extended message vertical alignment
				const h1 = _rootNode.querySelector('.notification h1');
				if (h1) {
					h1.style.marginBottom = '-10px';
				}

				const cancelButton = _rootNode.querySelector('.cancel');
				if (cancelButton) {
					cancelButton.addEventListener('click', function (e) {
						e.preventDefault();
						self.close();
					});
				}
			},
			info: function (message, duration, notification) {
				this.open('info', message, duration, notification);
			},
			warning: function (message, duration, notification) {
				this.open('warning', message, duration, notification);
			},
			update: function (message, duration, notification) {
				this.open('', message, duration, notification);
			},
			open: function (type, message, duration = 0, notification = false) {
				const self = this;

				self.close();

				if (typeof _timeout !== 'undefined') {
					clearTimeout(_timeout);
				}

				if (_rootNode) {
					_rootNode.className = 'update show ' + type;
					const h1 = _rootNode.querySelector('h1');
					if (h1) h1.textContent = message;
				}

				if (duration > 0) {
					_timeout = setTimeout(function () {
						self.close();
					}, duration);
				}

				if (notification) {
					_notify(message);
				}
			},
			close: function () {
				if (_rootNode) {
					_rootNode.classList.remove('show', 'extended');
				}
			},
		};
	})();

	// Wait for DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			bynder.modules.MessageBox.initialize();
		});
	} else {
		bynder.modules.MessageBox.initialize();
	}
}
